document.addEventListener('DOMContentLoaded', () => {
    const productPage = document.querySelector('[data-fls-productpage]');
    if (!productPage) return;

    const qtyInput = productPage.querySelector('[data-fls-qty-input]');
    const minusBtn = productPage.querySelector('[data-fls-qty-minus]');
    const plusBtn = productPage.querySelector('[data-fls-qty-plus]');
    const addToCartBtn = productPage.querySelector('[data-fls-add-to-cart]');
    const buyNowBtn = productPage.querySelector('[data-fls-buy-now]');
    const priceEl = productPage.querySelector('[data-fls-price]');
    const soldOutEl = productPage.querySelector('[data-fls-soldout]');
    const optionGroups = Array.from(productPage.querySelectorAll('.product-page__option'));
    const variantsJsonEl = document.querySelector('[data-product-json]');

    const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    };

    const moneyFormatAttr = productPage.getAttribute('data-money-format') || '{{amount}}';

    const formatMoney = (cents) => {
        const intCents = parseInt(cents, 10) || 0;

        if (window.Shopify && typeof Shopify.formatMoney === 'function') {
            return Shopify.formatMoney(intCents, moneyFormatAttr);
        }

        const value = (intCents / 100).toFixed(2);
        if (moneyFormatAttr.indexOf('{{amount}}') !== -1) {
            return moneyFormatAttr.replace('{{amount}}', value);
        }
        return value;
    };

    const getQuantity = () => {
        if (!qtyInput) return 1;
        const value = parseInt(qtyInput.value.replace(/[^\d]/g, ''), 10);
        return Number.isNaN(value) || value < 1 ? 1 : value;
    };

    const setQuantity = (value) => {
        if (!qtyInput) return;
        const safe = value < 1 ? 1 : value;
        qtyInput.value = String(safe);
    };

    const getVariantIdFromDOM = (buttonEl) => {
        if (!buttonEl) return null;
        const fromBtn = buttonEl.getAttribute('data-variant-id');
        if (fromBtn) return fromBtn;
        const wrapper = buttonEl.closest('[data-fls-product]');
        return wrapper ? wrapper.getAttribute('data-variant-id') : null;
    };

    const openCart = () => {
        if (window.flsCart && typeof window.flsCart.open === 'function') {
            window.flsCart.open();
        }
    };

    // -------- VARIANTS --------
    let variants = [];
    try {
        if (variantsJsonEl) {
            variants = JSON.parse(variantsJsonEl.textContent);
        }
    } catch (e) {
        console.error('Variants JSON parse error', e);
    }

    // Масив поточних опцій за позиціями (index = position - 1)
    const currentOptions = [];

    const initCurrentOptionsFromDOM = () => {
        optionGroups.forEach((group) => {
            const position = parseInt(group.getAttribute('data-option-position'), 10);
            const active = group.querySelector(
                '.product-page__option-value.is-active[data-option-value]',
            );
            if (!Number.isNaN(position) && active) {
                currentOptions[position - 1] = active.getAttribute('data-option-value');
            }
        });
    };

    const findVariantByOptions = (optionsArr) => {
        if (!variants.length || !optionsArr.length) return null;

        return (
            variants.find((variant) => {
                // option1 / option2 / option3
                for (let i = 0; i < optionsArr.length; i += 1) {
                    const value = optionsArr[i];
                    if (!value) continue;
                    const optionKey = `option${i + 1}`;
                    if (variant[optionKey] !== value) {
                        return false;
                    }
                }
                return true;
            }) || null
        );
    };

    const setVariantIdOnDOM = (variantId) => {
        if (!variantId) return;
        productPage.setAttribute('data-variant-id', variantId);

        if (addToCartBtn) {
            addToCartBtn.setAttribute('data-variant-id', variantId);
        }
        if (buyNowBtn) {
            buyNowBtn.setAttribute('data-variant-id', variantId);
        }
    };

    const setAvailabilityState = (available) => {
        const disabled = !available;

        if (addToCartBtn) {
            addToCartBtn.disabled = disabled;
            addToCartBtn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        }
        if (buyNowBtn) {
            buyNowBtn.disabled = disabled;
            buyNowBtn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        }
        if (qtyInput) {
            qtyInput.disabled = disabled;
        }
        if (minusBtn) {
            minusBtn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        }
        if (plusBtn) {
            plusBtn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        }

        if (soldOutEl) {
            if (disabled) {
                soldOutEl.classList.remove('product-page__status--hidden');
            } else {
                soldOutEl.classList.add('product-page__status--hidden');
            }
        }
    };

    const updateUIForVariant = (variant) => {
        if (!variant) {
            setAvailabilityState(false);
            return;
        }

        setVariantIdOnDOM(variant.id);

        if (priceEl) {
            priceEl.textContent = formatMoney(variant.price);
        }

        setAvailabilityState(!!variant.available);
    };

    // ------------- ADD TO CART -------------

    const addToCart = async (variantId, quantity = 1, options = {}) => {
        if (!variantId) return;

        const { clearCart = false } = options;

        try {
            if (clearCart) {
                await fetch('/cart/clear.js', {
                    method: 'POST',
                    headers,
                });
            }

            const res = await fetch('/cart/add.js', {
                method: 'POST',
                headers,
                body: JSON.stringify({
                    id: Number(variantId),
                    quantity: Number(quantity),
                }),
            });

            if (!res.ok) {
                console.error('Add to cart failed', await res.text());
                return;
            }

            openCart();
            document.dispatchEvent(new CustomEvent('cart:updated'));
        } catch (error) {
            console.error('Add to cart error', error);
        }
    };

    // ------------- QTY CONTROLS -------------

    if (minusBtn && qtyInput) {
        minusBtn.addEventListener('click', () => {
            const current = getQuantity();
            setQuantity(current - 1);
        });
    }

    if (plusBtn && qtyInput) {
        plusBtn.addEventListener('click', () => {
            const current = getQuantity();
            setQuantity(current + 1);
        });
    }

    if (qtyInput) {
        qtyInput.addEventListener('input', () => {
            const current = getQuantity();
            setQuantity(current);
        });
    }

    // ------------- VARIANT OPTION HANDLERS -------------

    initCurrentOptionsFromDOM();

    if (optionGroups.length && variants.length) {
        const initialVariantId = productPage.getAttribute('data-variant-id');
        let initialVariant = variants.find((v) => String(v.id) === String(initialVariantId));

        if (!initialVariant) {
            initialVariant = findVariantByOptions(currentOptions);
        }

        if (initialVariant) {
            updateUIForVariant(initialVariant);
        }

        optionGroups.forEach((group) => {
            const position = parseInt(group.getAttribute('data-option-position'), 10);
            if (Number.isNaN(position)) return;

            group.addEventListener('click', (event) => {
                const btn = event.target.closest('.product-page__option-value[data-option-value]');
                if (!btn) return;

                // активний стан
                group
                    .querySelectorAll('.product-page__option-value')
                    .forEach((el) => el.classList.remove('is-active'));
                btn.classList.add('is-active');

                const value = btn.getAttribute('data-option-value');
                currentOptions[position - 1] = value;

                const newVariant = findVariantByOptions(currentOptions);
                updateUIForVariant(newVariant);
            });
        });
    } else {
        // Якщо варіант один — просто підхоплюємо його стан
        const singleVariantId = productPage.getAttribute('data-variant-id');
        const singleVariant = variants.find((v) => String(v.id) === String(singleVariantId));
        if (singleVariant) {
            updateUIForVariant(singleVariant);
        }
    }

    // ------------- BUTTONS (ADD / BUY NOW) -------------

    if (addToCartBtn) {
        addToCartBtn.addEventListener('click', () => {
            if (addToCartBtn.disabled) return;
            const variantId = getVariantIdFromDOM(addToCartBtn);
            const quantity = getQuantity();
            addToCart(variantId, quantity, { clearCart: false });
        });
    }

    if (buyNowBtn) {
        buyNowBtn.addEventListener('click', () => {
            if (buyNowBtn.disabled) return;
            const variantId = getVariantIdFromDOM(buyNowBtn);
            const quantity = getQuantity();
            addToCart(variantId, quantity, { clearCart: true });
        });
    }
});

// Temporary fix: Notify Me / ReStock app sometimes injects preorder badge
// into the wrong product card in product sliders.
// Keep badge only for real preorder variant IDs.
(function () {
  const VALID_PREORDER_VARIANT_IDS = ['57306953122124'];

  function cleanupWrongPreorderBadges() {
    document.querySelectorAll('.product').forEach((productEl) => {
      const variantId = productEl.getAttribute('data-variant-id');

      const isValidPreorder = VALID_PREORDER_VARIANT_IDS.includes(String(variantId));

      if (!isValidPreorder) {
        productEl.querySelectorAll('.hengam-product-price-wrapper').forEach((el) => {
          el.remove();
        });

        productEl.querySelectorAll('.product__price').forEach((el) => {
          el.style.setProperty('display', 'inline', 'important');
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', cleanupWrongPreorderBadges);

  setTimeout(cleanupWrongPreorderBadges, 500);
  setTimeout(cleanupWrongPreorderBadges, 1500);
  setTimeout(cleanupWrongPreorderBadges, 3000);
})();